// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"385":"a31a63c7","485":"974dddaf","787":"d6842f55"}[chunkId] + ".chunk.js";
};